export class LocalJson {
  localJson() {
    return {
      carrierCode: {
        xj: "Operated by Thai AirAsia X",
        dj: "Operated by AirAsia Japan",
        ak: "Operated by AirAsia Berhad (Malaysia)",
        qz: "Operated by Indonesia AirAsia",
        i5: "Operated by AirAsia India",
        fd: "Operated by Thai AirAsia",
        xt: "Operated by Indonesia AirAsia Extra",
        d7: "Operated by AirAsia X",
        z2: "Operated by Philippines AirAsia",
        kt: "Operated by Cambodia AirAsia",
      },
      search: {
        origin: "From",
        startDate: "Start Date",
        search: "Search",
        endDate: "End Date",
        flightstatus: "Flight status",
        destination: "To",
        flightNumber: "Flight number",
        searchRoute: "Search by route",
        searchPNR: "Search by Booking Number",
        airlinecode: "Airline code",
        bookingNumber: "Booking number",
        flightNumberTooltip:
          "Enter your airline code and flight number.\nExample: AK6117\nImportant: Use Uppercase",
        searchFlightNumber: "Search by flight number",
        searchBookingNumber: "Search by booking number",
        findFlights: "Find flights",
      },
      result: {
        departed: "Departed",
        onTime: "On time",
        sat: "Sat",
        scheduledArrival: "Scheduled arrival",
        wed: "Wed",
        sun: "Sun",
        fri: "Fri",
        scheduledDeparture: "Scheduled departure",
        actualDeparture: "Actual departure",
        scheduled: "Scheduled",
        lastUpdate: "Last updated on {x}",
        delayed: "Delayed",
        diverted: "Diverted",
        spillovers: "+1 : Flight arrives the next day. ",
        inFlight: "In flight",
        landed: "Landed",
        estimatedArrival: "Estimated arrival",
        arrived: "Arrived",
        mon: "Mon",
        notDeparted: "Not yet departed",
        tue: "Tue",
        localTime:
          "All times displayed are the selected airport malaysia local time.",
        thu: "Thu",
        estimatedDeparture: "Estimated departure",
        actualArrival: "Actual arrival",
        cancelled: "Cancelled",
        flightReturn: "Flight Return",
        rampReturn: "Ramp Return",
        actualReturn: "Actual Return",
        earlyDeparture: "Early departure",
        showMore: "Show more flights",
      },
      errorMessage: {
        serverDown:
          "We can't display any flights at this moment. Try again later",
        noDestination: "We're unable to load destination list",
        noFlightToday: "No flights today.",
        invalidFlightNumber:
          "Flight number must start with a valid airline code.\nExample: AK, FD",
        invalidBookingNumber:
          "Flight number must start with a valid airline code.\nExample: AK, FD",
        noOrigin: "We're unable to load origin list",
        oops: "Oops!",
        error: "Error",
        noResult: "No results found",
        noFlight:
          "Oops! We can't find any flights matching your request. Check your details and try again!",
      },
      noFlightAndCancelledLink: {
        url: "https://support.airasia.com/s/all-travel-notices?language=en_GB",
        text2: "to check if your flight is affected",
        text1:
          "No scheduled flights today or the flights might have been cancelled.",
        callToAction: "Click here",
        newTab: "TRUE",
      },
      seo: {
        pageTitle:
          "AirAsia Flight Status - Get Up To Date Flight Information | AirAsia",
        metaDescription:
          "Get real-time information on any AirAsia flight status. Find out your flight's actual departure and arrival times, delays and cancellations conveniently.",
      },
      sns: {
        image: "https://a.staticaa.com/images/misc/flight-status-sns.jpg",
        description:
          "Get real-time information on any AirAsia flight status. Find out your flight's actual departure and arrival times, delays and cancellations conveniently.",
        title: "AirAsia Flight Status - Get Up To Date Flight Information",
      },
      accessibility: {
        labelEmptyOrigin: "Select an origin city",
        navigationCombobox:
          "Browse cities by using the up and down arrows and select by pressing enter. Touch device users can browse cities with touching or swiping gestures.",
        labelLoadComplete:
          "There are 4 flights on this date. Hit tab to navigate between flights.",
        labelDate:
          "Display flight status for Thursday, 4 April 2019. Hit enter on your keyboard or tap to display all flights.",
        labelErrorLoading:
          "This page cannot display any flight status because of an error. Refresh the page and try again.",
        labelEmptyDestination: "Select a destination",
        labelLoading: "Please wait while we process your request.",
        labelFligthStatus:
          "Flight D7 222 status on time scheduled to depart kuala lumpur at 00.15 arrive at osaka at 06.30 carrier code D7 ",
        labelNoFlights: "There are no flights on this day",
      },
    };
  }
}
